import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M15.5 5.5L12 2L8.5 5.5L9.207 6.207L11.5 3.914V22H12.5V3.914L14.793 6.207L15.5 5.5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ThinLongUp"
);
